import { DesktopMac } from "@mui/icons-material";
import { Box, Stack, Typography, alpha, styled } from "@mui/material";
import { ReactComponent as Logo } from "Assets/Images/logo-no-symbol.svg";
import slice1 from "Assets/backgrounds/login/slice-1.png";
import { motion } from "motion/react";

const PageRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100dvh",
  padding: theme.spacing(4, 3),
  backgroundColor: theme.palette.primary.dark,
  backgroundImage: `
    linear-gradient(145deg, ${alpha(theme.palette.primary.dark, 0.97)} 0%, ${alpha("#3a1670", 0.94)} 50%, ${alpha(theme.palette.primary.dark, 0.9)} 100%),
    url(${slice1})
  `,
  backgroundPosition: "left top, -80px top",
  backgroundRepeat: "no-repeat, no-repeat",
  backgroundSize: "cover, 520px",
}));

const ContentCard = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: 400,
  padding: theme.spacing(5, 3.5),
  borderRadius: 16,
  backgroundColor: theme.palette.common.white,
  boxShadow: `0 24px 80px ${alpha(theme.palette.primary.dark, 0.12)}`,
  border: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
  textAlign: "center",
}));

const IconCircle = styled(Box)(({ theme }) => ({
  width: 72,
  height: 72,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto",
  marginBottom: theme.spacing(3),
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
  color: theme.palette.primary.main,
}));

interface IDesktopRequiredScreenProps {
  children?: React.ReactNode;
}
function DesktopRequiredScreen({ children }: IDesktopRequiredScreenProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <PageRoot>
        <Logo height={40} width={240} style={{ marginBottom: 32 }} />
        <ContentCard>
          {children ? (
            children
          ) : (
            <>
              <IconCircle>
                <DesktopMac sx={{ fontSize: 36 }} />
              </IconCircle>
              <Stack spacing={1.5}>
                <Typography variant="h4" fontWeight={700}>
                  Best viewed on desktop
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ lineHeight: 1.6 }}
                >
                  Incendium is designed for larger screens. Please open this
                  page on a laptop or desktop computer for the full experience.
                </Typography>
              </Stack>
            </>
          )}
        </ContentCard>
      </PageRoot>
    </motion.div>
  );
}

export default DesktopRequiredScreen;
